import { render, staticRenderFns } from "./AddBatchRevenueDialog.vue?vue&type=template&id=29a422b1&scoped=true"
import script from "./AddBatchRevenueDialog.vue?vue&type=script&lang=js"
export * from "./AddBatchRevenueDialog.vue?vue&type=script&lang=js"
import style0 from "./AddBatchRevenueDialog.vue?vue&type=style&index=0&id=29a422b1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a422b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a422b1')) {
      api.createRecord('29a422b1', component.options)
    } else {
      api.reload('29a422b1', component.options)
    }
    module.hot.accept("./AddBatchRevenueDialog.vue?vue&type=template&id=29a422b1&scoped=true", function () {
      api.rerender('29a422b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/AddBatchRevenueDialog.vue"
export default component.exports